"use client"

import * as React from "react"
import { Bar, BarChart, CartesianGrid, XAxis } from "recharts"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "src/@/components/ui/card";

import {
    ChartContainer,
    ChartLegend,
    ChartLegendContent,
    ChartTooltip,
    ChartTooltipContent,
} from "src/@/components/ui/chart";

import EmptyContentGhost from "src/components/EmptyContentGhost"

// Helper function to generate a color palette dynamically
const generateColorPalette = (keys) => {
    const baseColor = { h: 260, s: 70, l: 80 }; // HSL representation of #DACFFB
    return keys.reduce((acc, key, index) => {
        const hueShift = (baseColor.h + index * 60) % 360; // Adjust hue for variation
        const color = `hsl(${hueShift}, ${baseColor.s}%, ${baseColor.l}%)`;
        acc[key] = {
            label: key,
            color,
        };
        return acc;
    }, {});
};

export function GraficoNegociosGanhosPeriodo({ chartData }) {
    // Extract keys dynamically from the chartData (excluding "ano_mes")
    const keys = Object.keys(chartData?.[0] || {}).filter((key) => key !== "ano_mes");

    // Generate chart configuration dynamically
    const chartConfig = generateColorPalette(keys);

    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <CardTitle>Negócios ganhos no período</CardTitle>
                    <CardDescription>
                        Ganhos e perdas de leads nos últimos 6 meses
                    </CardDescription>
                </div>

            </CardHeader>
            <CardContent>
                {
                    chartData?.length === 0 ? (
                        <EmptyContentGhost />
                    ) : (
                        <div>
                            <ChartContainer className="h-[300px] w-full" config={chartConfig}>
                                <BarChart accessibilityLayer data={chartData}>
                                    <CartesianGrid vertical={false} />
                                    <XAxis
                                        dataKey="ano_mes"
                                        tickLine={false}
                                        tickMargin={2}
                                        axisLine={false}
                                    />
                                    <ChartTooltip content={<ChartTooltipContent hideLabel />} />
                                    <ChartLegend content={<ChartLegendContent />} />
                                    {
                                        keys.map((key) => (
                                            <Bar
                                                key={key}
                                                dataKey={key}
                                                barSize={50}
                                                stackId="a"
                                                fill={chartConfig[key].color}
                                            />
                                        ))
                                    }
                                </BarChart>
                            </ChartContainer>
                        </div>
                    )
                }

            </CardContent>
        </Card>
    )
}
